export enum CancelStatus {
  NotCanceled = 'NotCanceled',
  LeftEyeCanceled = 'LeftEyeCanceled',
  RightEyeCanceled = 'RightEyeCanceled',
  BothEyesCanceled = 'BothEyesCanceled',
}
